import React from "react";
import PropTypes from "prop-types";
import { FaCheck, FaCode, FaDownload, FaRedoAlt, FaCloudUploadAlt, FaSyncAlt, FaUndo, FaTimes, FaSpinner } from "react-icons/fa";
import Clickable from "../common/Clickable";

// Pieces shared by the Journal tab and each journal section.

export const STATE_BADGE = {
  draft:  { label: "Not created in ERP", tone: "tw-bg-geist-100 tw-text-geist-fg-2" },
  on_erp: { label: "In ERP · not posted", tone: "tw-bg-[#eef4ff] tw-text-geist-accent" },
  locked: { label: "Locked", tone: "tw-bg-[#fff8ee] tw-text-[#a05e03]" },
};

export const StateBadge = ({ state }) => {
  const badge = STATE_BADGE[state] || STATE_BADGE.draft;
  return <span className={`tw-px-2 tw-py-0.5 tw-rounded tw-text-[11px] tw-font-semibold tw-whitespace-nowrap ${badge.tone}`}>{badge.label}</span>;
};

StateBadge.propTypes = { state: PropTypes.string };

const hhmm = (iso) => (iso ? String(iso).replace("T", " ").slice(11, 16) : "");

// Số liệu đang hiện đến từ đâu. Chưa có bút toán thì không đọc AX, không nói gì.
export const ReadSource = ({ read }) => {
  if (!read) return null;
  if (read.source === "erp") {
    return <span className="tw-text-[12px] tw-text-geist-fg-3"><i className="bi bi-check2-circle tw-mr-1" />Read from AX at {hhmm(read.read_at)}</span>;
  }
  if (read.source === "cache") {
    return (
      <span className="tw-text-[12px] tw-text-[#a05e03]" title={read.error}>
        <i className="bi bi-exclamation-triangle tw-mr-1" />AX did not answer — showing the copy saved in Portal
      </span>
    );
  }
  return null;
};

ReadSource.propTypes = { read: PropTypes.object };

const ACTION_ICONS = {
  'bi-check2': FaCheck, 'bi-cloud-upload': FaCloudUploadAlt, 'bi-cloud-arrow-up': FaCloudUploadAlt,
  'bi-arrow-repeat': FaSyncAlt, 'bi-arrow-counterclockwise': FaUndo, 'bi-x-lg': FaTimes,
  'bi-download': FaDownload, 'bi-arrow-clockwise': FaRedoAlt, 'bi-file-code': FaCode,
};

// `loading`: the action is running — spinner instead of the icon, and no second click.
export const ActionButton = ({ onClick, disabled, loading = false, icon, children, tone = "default", title }) => {
  const Icon = ACTION_ICONS[icon];
  disabled = disabled || loading;
  return <Clickable disabled={disabled} aria-busy={loading || undefined} data-tone={tone} title={title} onClick={disabled ? undefined : onClick}
    className={`payment-journal-action tw-inline-flex tw-items-center tw-gap-1.5 tw-h-9 tw-px-3 tw-rounded-geist-sm tw-border tw-border-solid tw-text-[13px] tw-font-semibold ${
      disabled ? "tw-border-geist-border tw-text-geist-fg-3"
        : tone === "primary" ? "tw-border-geist-accent tw-bg-geist-accent tw-text-white hover:tw-bg-geist-accent-2"
          : tone === "warn" ? "tw-border-[#f0b45a] tw-text-[#a05e03] hover:tw-bg-[#fff8ee]"
            : "tw-border-geist-border tw-text-geist-fg-2 hover:tw-bg-geist-100"}`}>
    {loading ? <FaSpinner aria-hidden="true" size={14} className="tw-animate-spin" /> : Icon && <Icon aria-hidden="true" size={14} />} {children}
  </Clickable>;
};

ActionButton.propTypes = {
  onClick: PropTypes.func, disabled: PropTypes.bool, loading: PropTypes.bool, icon: PropTypes.string, children: PropTypes.node, tone: PropTypes.string, title: PropTypes.string,
};
